import { useState } from "react";
import { Link } from "react-router-dom";

type Question = {
  model: string;
  correct: string;
  options: string[];
  hint: string;
};

const ALL_QUESTIONS: Question[] = [
  // BMW
  {
    model: "430d xDrive Gran Coupé",
    correct: "BMW",
    options: ["BMW", "Audi", "Mercedes-Benz", "Porsche"],
    hint: "4 = Sèrie 4 (coupé derivat de la 3). 30 = nivell de potència mig. d = dièsel. xDrive = tracció total.",
  },
  {
    model: "M3 Competition xDrive",
    correct: "BMW",
    options: ["BMW", "Mercedes-Benz", "Audi", "Porsche"],
    hint: "Les M pures de BMW (M2, M3, M4, M5...) son models de competició completament independents, no confondre amb el pack estètic M Sport.",
  },
  {
    model: "iX M60",
    correct: "BMW",
    options: ["BMW", "Mercedes-Benz", "Audi", "Polestar"],
    hint: "La 'i' davant a BMW indica vehicle elèctric. iX = SUV elèctric flagship. M60 = versió de màxima potència.",
  },
  {
    model: "X3 M Competition",
    correct: "BMW",
    options: ["BMW", "Audi", "Mercedes-Benz", "Land Rover"],
    hint: "X = família SUV de BMW. X3 = mida mitjana. M Competition = versió d'alt rendiment AMG equivalent.",
  },
  {
    model: "840i Gran Coupé xDrive",
    correct: "BMW",
    options: ["BMW", "Mercedes-Benz", "Audi", "Porsche"],
    hint: "8 = Sèrie 8, el coupé/gran coupé de luxe de BMW. 40 = potència alta. i = gasolina. xDrive = tracció total.",
  },
  // Mercedes-Benz
  {
    model: "E 300 de 4MATIC",
    correct: "Mercedes-Benz",
    options: ["Mercedes-Benz", "BMW", "Audi", "Volvo"],
    hint: "Classe E = berlina executiva Mercedes. 300 = potència relativa. d = dièsel. e = hybrid endollable (PHEV). 4MATIC = tracció total.",
  },
  {
    model: "GLC 300 4MATIC Coupé",
    correct: "Mercedes-Benz",
    options: ["Mercedes-Benz", "BMW", "Audi", "Land Rover"],
    hint: "GL- = prefixe de SUV a Mercedes. GLC = SUV equivalent a la Classe C. Coupé = variant amb teulada inclinada. 4MATIC = tracció total.",
  },
  {
    model: "EQS 450+",
    correct: "Mercedes-Benz",
    options: ["Mercedes-Benz", "BMW", "Audi", "Polestar"],
    hint: "EQ = gamma completament elèctrica de Mercedes. EQS = la berlina elèctrica flagship, equivalent a la Classe S però elèctrica.",
  },
  {
    model: "G 63 AMG",
    correct: "Mercedes-Benz",
    options: ["Mercedes-Benz", "BMW", "Porsche", "Land Rover"],
    hint: "Classe G = el llegendari tot terreny de Mercedes, en producció des del 1979. 63 AMG = motor biturbo V8 de 585 CV.",
  },
  {
    model: "CLS 53 AMG 4MATIC+",
    correct: "Mercedes-Benz",
    options: ["Mercedes-Benz", "BMW", "Audi", "Porsche"],
    hint: "CLS = el coupé de 4 portes de Mercedes, amb línia de sostre inclinada. 53 AMG = motor 6 cilindres AMG de ≈435 CV.",
  },
  {
    model: "AMG GT 63 S E Performance",
    correct: "Mercedes-Benz",
    options: ["Mercedes-Benz", "Porsche", "Audi", "Ferrari"],
    hint: "AMG GT = model esportiu propi d'AMG (no basat en cap Classe). 63 S = V8 biturbo. E Performance = PHEV AMG d'altíssima potència.",
  },
  // Audi
  {
    model: "RS6 Avant Performance",
    correct: "Audi",
    options: ["Audi", "BMW", "Mercedes-Benz", "Porsche"],
    hint: "RS = Rennsport (esport de curses), la versió de màxim rendiment a Audi. 6 = basat en l'A6. Avant = carrosseria familiar.",
  },
  {
    model: "Q5 Sportback 45 TFSI quattro",
    correct: "Audi",
    options: ["Audi", "BMW", "Mercedes-Benz", "Volkswagen"],
    hint: "Q = família SUV d'Audi. Q5 = mida mitjana. 45 = codi de potència Audi (≈245 CV). TFSI = gasolina turbo. quattro = tracció integral.",
  },
  {
    model: "S7 Sportback TDI",
    correct: "Audi",
    options: ["Audi", "BMW", "Mercedes-Benz", "Porsche"],
    hint: "S = versió esportiva d'Audi (un pas per sota de RS). 7 = basat en l'A7. Sportback = carrosseria fastback de 5 portes.",
  },
  {
    model: "e-tron GT RS",
    correct: "Audi",
    options: ["Audi", "BMW", "Mercedes-Benz", "Porsche"],
    hint: "e-tron GT = gran turisme totalment elèctric d'Audi. RS = versió de màxima potència. Comparteix plataforma amb el Porsche Taycan.",
  },
  {
    model: "SQ8 TDI",
    correct: "Audi",
    options: ["Audi", "BMW", "Mercedes-Benz", "Porsche"],
    hint: "S = versió esportiva. Q8 = el SUV coupé gran d'Audi, rival del BMW X6/GLE Coupé. TDI = dièsel turbo.",
  },
  // Porsche
  {
    model: "911 GT3 RS",
    correct: "Porsche",
    options: ["Porsche", "BMW", "Audi", "Ferrari"],
    hint: "911 = model icònic de Porsche. GT3 = versió de circuit pura, atmosfèrica. RS = Rennsport, la variant més extrema i lleugera del GT3.",
  },
  {
    model: "Taycan Turbo S Cross Turismo",
    correct: "Porsche",
    options: ["Porsche", "BMW", "Audi", "Mercedes-Benz"],
    hint: "Taycan = berlina elèctrica de Porsche. Turbo S = màxima potència (malgrat el nom, no té turbo, és elèctric). Cross Turismo = variant familiar aventurera.",
  },
  {
    model: "Cayenne Coupé GTS",
    correct: "Porsche",
    options: ["Porsche", "BMW", "Land Rover", "Audi"],
    hint: "Cayenne = SUV de Porsche. Coupé = variant amb teulada inclinada. GTS = Gran Turismo Sport, la tercera posició en la jerarquia del Cayenne.",
  },
  {
    model: "718 Boxster GTS 4.0",
    correct: "Porsche",
    options: ["Porsche", "BMW", "Audi", "Ferrari"],
    hint: "718 = homenatge als Porsche de competició dels anys 50-60. Boxster = roadster de mig motor. 4.0 = motor atmosfèric de 4.0 litres i 400 CV.",
  },
  {
    model: "Panamera 4S E-Hybrid",
    correct: "Porsche",
    options: ["Porsche", "BMW", "Mercedes-Benz", "Maserati"],
    hint: "Panamera = berlina de luxe de 4 portes de Porsche. 4S = tracció total + variant S (potència mitja-alta). E-Hybrid = PHEV endollable.",
  },
  // Altres marques
  {
    model: "Stelvio Quadrifoglio",
    correct: "Alfa Romeo",
    options: ["Alfa Romeo", "Maserati", "Ferrari", "Fiat"],
    hint: "Stelvio = SUV d'Alfa Romeo, nom del famós coll del Stelvio. Quadrifoglio = el trébol de quatre fulles, símbol de màxima potència a Alfa Romeo.",
  },
  {
    model: "Continental GT Speed",
    correct: "Bentley",
    options: ["Bentley", "Rolls-Royce", "Aston Martin", "Porsche"],
    hint: "Continental GT és el Gran Turisme icònic de Bentley. Speed = la variant de màxima potència, amb el W12 biturbo de 659 CV.",
  },
  {
    model: "F-Pace SVR",
    correct: "Jaguar",
    options: ["Jaguar", "Land Rover", "Aston Martin", "Porsche"],
    hint: "F-Pace = el SUV esportiu de Jaguar. SVR = Special Vehicle Racing, el programa d'alt rendiment de Jaguar, similar a AMG/M.",
  },
  {
    model: "DB11 Volante AMR",
    correct: "Aston Martin",
    options: ["Aston Martin", "Jaguar", "Bentley", "Rolls-Royce"],
    hint: "DB = David Brown, el propietari que va salvar Aston Martin als anys 50. DB11 = 11a generació. Volante = descapotable. AMR = Aston Martin Racing.",
  },
  {
    model: "Levante Trofeo Performance",
    correct: "Maserati",
    options: ["Maserati", "Ferrari", "Alfa Romeo", "Lamborghini"],
    hint: "Levante = el SUV de Maserati. Trofeo = variant V8 biturbo de 590 CV de Ferrari, la versió de màxima potència del Levante.",
  },
  {
    model: "XC60 Recharge T8",
    correct: "Volvo",
    options: ["Volvo", "Polestar", "BMW", "Mercedes-Benz"],
    hint: "XC = Cross Country (SUV de Volvo). 60 = mida mitjana. Recharge = gamme electrificada. T8 = PHEV amb motor de gasolina + elèctric.",
  },
  {
    model: "Formentor VZ5",
    correct: "CUPRA",
    options: ["CUPRA", "SEAT", "Volkswagen", "Skoda"],
    hint: "Formentor = el primer model exclusiu de CUPRA, no basat en cap SEAT. VZ = Veloz. 5 = motor 5 cilindres en línia d'Audi de 390 CV.",
  },
  {
    model: "Huracán Tecnica",
    correct: "Lamborghini",
    options: ["Lamborghini", "Ferrari", "Porsche", "McLaren"],
    hint: "Huracán = el superesportiu 'd'entrada' de Lamborghini (relatiu!). Tecnica = versió RWD de tracció posterior, el més equilibrat per a carretera.",
  },
  {
    model: "GranTurismo Folgore",
    correct: "Maserati",
    options: ["Maserati", "Ferrari", "Alfa Romeo", "Lamborghini"],
    hint: "GranTurismo = el coupé esportiu icònic de Maserati. Folgore (llamp en italià) = versió totalment elèctrica, el debut EV de Maserati.",
  },
  {
    model: "Giulia Estrema",
    correct: "Alfa Romeo",
    options: ["Alfa Romeo", "Ferrari", "Maserati", "Fiat"],
    hint: "Giulia = la berlina de mida mitjana d'Alfa Romeo. Estrema = versió de màxima dotació, el cim de la gamma amb peces de fibra de carboni.",
  },
];

const BRAND_LOGOS: Record<string, string> = {
  "BMW": "/logos/bmw-logo.png",
  "Mercedes-Benz": "/logos/mercedes-benz-logo.png",
  "Audi": "/logos/audi-logo.png",
  "Porsche": "/logos/porsche-logo.png",
  "Alfa Romeo": "/logos/alfa-romeo-logo.png",
  "Bentley": "/logos/bentley-logo.png",
  "Jaguar": "/logos/jaguar-logo.png",
  "Aston Martin": "/logos/aston-martin-logo.png",
  "Maserati": "/logos/maserati-logo.png",
  "Volvo": "/logos/volvo-logo.png",
  "CUPRA": "/logos/cupra-logo.png",
  "SEAT": "/logos/seat-logo.png",
  "Volkswagen": "/logos/volkswagen-logo.png",
  "Skoda": "/logos/skoda-logo.png",
  "Land Rover": "/logos/land-rover-logo.png",
  "Ferrari": "/logos/ferrari-logo.png",
  "Lamborghini": "/logos/lamborghini-logo.png",
  "Rolls-Royce": "/logos/rolls-royce-logo.png",
  "McLaren": "/logos/mclaren-logo.png",
  "Polestar": "/logos/polestar-logo.png",
  "Fiat": "/logos/fiat-logo.png",
};

const TOTAL = 20;

function shuffle<T>(arr: T[]): T[] {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const generateQuestions = (): Question[] =>
  shuffle(ALL_QUESTIONS)
    .slice(0, TOTAL)
    .map((q) => ({ ...q, options: shuffle(q.options) }));

export const TestModels = () => {
  const [questions, setQuestions] = useState<Question[]>(generateQuestions);
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState<string | null>(null);
  const [score, setScore] = useState(0);
  const [finished, setFinished] = useState(false);

  const question = questions[current];
  const answered = selected !== null;

  const handleSelect = (brand: string) => {
    if (answered) return;
    setSelected(brand);
    if (brand === question.correct) {
      setScore((s) => s + 1);
    }
  };

  const handleNext = () => {
    if (current + 1 >= TOTAL) {
      setFinished(true);
    } else {
      setCurrent((c) => c + 1);
      setSelected(null);
    }
  };

  const handleRetry = () => {
    setQuestions(generateQuestions());
    setCurrent(0);
    setSelected(null);
    setScore(0);
    setFinished(false);
  };

  if (finished) {
    const pct = Math.round((score / TOTAL) * 100);
    const { badge, color } =
      pct === 100
        ? { badge: "Mestre dels models", color: "#eab308" }
        : pct >= 85
        ? { badge: "Expert", color: "#22c55e" }
        : pct >= 65
        ? { badge: "Entès", color: "#3b82f6" }
        : pct >= 40
        ? { badge: "Aficionat", color: "#f97316" }
        : { badge: "Principiant", color: "#6b7280" };

    return (
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 max-w-2xl">
          <div className="mb-8">
            <Link
              to="/guia-models/test"
              className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m15 18-6-6 6-6" />
              </svg>
              Tornar als tests
            </Link>
          </div>

          <div className="bg-card border border-border rounded-2xl p-8 sm:p-10 text-center">
            <div className="text-5xl mb-5">
              {pct === 100 ? "🏆" : pct >= 85 ? "🌟" : pct >= 65 ? "👍" : pct >= 40 ? "📚" : "🔍"}
            </div>
            <h2 className="text-2xl font-bold mb-1 text-foreground">Resultat final</h2>
            <div className="text-6xl font-bold mb-1 text-foreground mt-4">
              {score}
              <span className="text-3xl text-muted-foreground">/{TOTAL}</span>
            </div>
            <div className="text-base font-semibold mt-2 mb-7" style={{ color }}>
              {badge}
            </div>

            <div className="w-full bg-secondary rounded-full h-2 mb-8 overflow-hidden">
              <div
                className="h-2 rounded-full transition-all duration-700"
                style={{ width: `${pct}%`, backgroundColor: color }}
              />
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={handleRetry}
                className="px-6 py-3 bg-foreground text-background rounded-xl font-semibold text-sm hover:opacity-80 transition-opacity"
              >
                Tornar a intentar
              </button>
              <Link
                to="/guia-models/test"
                className="px-6 py-3 bg-card border border-border text-foreground rounded-xl font-semibold text-sm hover:bg-secondary transition-colors text-center"
              >
                Altres tests
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 max-w-2xl">
        {/* Back link */}
        <div className="mb-6">
          <Link
            to="/guia-models/test"
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6" />
            </svg>
            Tornar als tests
          </Link>
        </div>

        {/* Header */}
        <div className="mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-foreground mb-1.5">
            Test de marques
          </h1>
          <p className="text-muted-foreground text-sm sm:text-base">
            Identifica a quina marca pertany cada model. {TOTAL} preguntes.
          </p>
        </div>

        {/* Progress */}
        <div className="mb-6">
          <div className="flex justify-between items-center mb-2">
            <span className="text-xs text-muted-foreground font-medium">
              Pregunta {current + 1} de {TOTAL}
            </span>
            <span className="text-xs font-bold text-foreground">
              {score} correctes
            </span>
          </div>
          <div className="w-full bg-secondary rounded-full h-1.5 overflow-hidden">
            <div
              className="h-1.5 rounded-full bg-foreground transition-all duration-300"
              style={{ width: `${(current / TOTAL) * 100}%` }}
            />
          </div>
        </div>

        {/* Question card */}
        <div className="bg-card border border-border rounded-2xl overflow-hidden">
          {/* Model name */}
          <div className="px-6 py-8 text-center border-b border-border">
            <p className="text-[11px] font-bold text-muted-foreground uppercase tracking-widest mb-5">
              A quina marca pertany?
            </p>
            <div className="inline-block px-6 py-3.5 rounded-xl bg-secondary border border-border">
              <span className="text-xl sm:text-2xl font-bold font-mono text-foreground tracking-tight">
                {question.model}
              </span>
            </div>
          </div>

          {/* Options */}
          <div className="p-5 sm:p-6">
            <div className="grid grid-cols-2 gap-2.5">
              {question.options.map((brand) => {
                let cls =
                  "flex items-center gap-2.5 p-3.5 rounded-xl border font-semibold text-sm transition-all text-left w-full ";

                if (!answered) {
                  cls +=
                    "border-border hover:border-foreground/40 hover:bg-secondary cursor-pointer";
                } else if (brand === question.correct) {
                  cls +=
                    "border-green-500 bg-green-500/10 text-green-600 dark:text-green-400 cursor-default";
                } else if (brand === selected) {
                  cls +=
                    "border-red-500 bg-red-500/10 text-red-600 dark:text-red-400 cursor-default";
                } else {
                  cls += "border-border opacity-35 cursor-default";
                }

                return (
                  <button
                    key={brand}
                    className={cls}
                    onClick={() => handleSelect(brand)}
                    disabled={answered}
                  >
                    <div className="w-7 h-7 rounded-lg overflow-hidden bg-white border border-black/10 dark:border-white/15 flex items-center justify-center shrink-0 p-0.5">
                      <img
                        src={BRAND_LOGOS[brand] || ""}
                        alt={brand}
                        className="w-full h-full object-contain"
                        onError={(e) => {
                          e.currentTarget.style.display = "none";
                        }}
                      />
                    </div>
                    <span className="leading-tight">{brand}</span>
                    {answered && brand === question.correct && (
                      <svg
                        className="ml-auto shrink-0"
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 6 9 17l-5-5" />
                      </svg>
                    )}
                    {answered && brand === selected && brand !== question.correct && (
                      <svg
                        className="ml-auto shrink-0"
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                      </svg>
                    )}
                  </button>
                );
              })}
            </div>

            {/* Hint after answering */}
            {answered && (
              <div className="mt-4 flex gap-3 p-4 bg-secondary/60 border border-border rounded-xl">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="shrink-0 mt-0.5 text-muted-foreground"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 16v-4" />
                  <path d="M12 8h.01" />
                </svg>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {question.hint}
                </p>
              </div>
            )}

            {/* Next button */}
            {answered && (
              <button
                onClick={handleNext}
                className="mt-3 w-full py-3 bg-foreground text-background rounded-xl font-semibold text-sm hover:opacity-80 transition-opacity"
              >
                {current + 1 >= TOTAL ? "Veure resultats" : "Següent pregunta →"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
